<template>
	<div class="list">
		<div
			class="list_wrap"
			v-if="!type || type == 'download'"
			@scroll="onScroll"
		>
			<div class="list_top" v-if="isChangeStatus">
				<a href="javascript:;" class="add_btn" @click="showAdd"
					>添加下载链接</a
				>
				<a
					href="javascript:;"
					class="top_btn pause_btn"
					@click="pauseAllTask"
					>全部暂停</a
				>
				<a
					href="javascript:;"
					class="top_btn start_btn"
					@click="startAllTask"
					>全部开始</a
				>
				<a
					href="javascript:;"
					class="batch_btn"
					v-if="$store.state.downloadTaskInfoList.length > 0"
					@click="ChangeStatus"
					>批量操作</a
				>
				<!-- <a href="javascript:;" class="top_btn del_btn @click="batchOperation"">删除</a> -->
			</div>
			<div class="batch_box" v-if="!isChangeStatus">
				<div class="batch_box_checkmsg">
					已选中{{ downloadingSelectedArray.length }}个项目
				</div>
				<div class="top_btn all_btn" @click="checkedAll">
					<img
						src="../assets/top_allchecked.png"
						v-show="isAllChecked == true"
						alt
					/>
					<img
						src="../assets/unchecked.png"
						v-show="isAllChecked == false"
						alt
					/>
					<span>全选</span>
				</div>
				<div class="top_btn all_btn" @click="checkedAllfail">
					<img
						src="../assets/top_allfail_btn.png"
						v-show="isAllfailChecked == true"
						alt
					/>
					<img
						src="../assets/unchecked.png"
						v-show="isAllfailChecked == false"
						alt
					/>
					<span>所有失败</span>
				</div>
				<div
					class="top_btn del_btn"
					v-if="downloadingSelectedArray.length > 0"
					@click="showAllDel($store.state.downloadTaskInfoList)"
				>
					<img src="../assets/top_del_btn.png" alt />
					<span>删除</span>
				</div>
				<div class="top_btn del_btn_disable" v-else>
					<img src="../assets/top_del_btn_disable.png" alt />
					<span>删除</span>
				</div>
				<a href="javascript:;" class="finish_btn" @click="checkedFinish"
					>完成</a
				>
			</div>
			<div
				class="list_item"
				:class="{
					list_item_checked: downloadingSelectedArray.includes(
						item.taskid
					),
				}"
				:key="item.taskid"
				v-for="item in $store.state.downloadTaskInfoList"
				@click="isChangeStatus == false ? changeChecked(item) : ''"
			>
				<div class="task_type">
					<img :src="bt_icon" />
				</div>
				<div class="task_file">
					<div
						class="task_name"
						:title="item.name ? item.name : item.url"
					>
						{{ item.name ? item.name : item.url }}
					</div>
					<div class="task_size">
						{{ $common.formatSize(item.dlSize) }} /
						{{ $common.formatSize(item.size) }}
					</div>
				</div>
				<div class="task_time">
					{{ $common.formatTime(item.downTime) }}
				</div>
				<div class="task_progress">
					<div class="task_progress_wrap">
						<div
							class="task_progress_percent"
							:style="{
								width: getDownloadPercent(
									item.dlSize,
									item.size,
									item.state
								),
							}"
						></div>
					</div>
					<div
						class="task_speed"
						v-html="
							getDownloadSpeed(
								item.dlSpeed,
								item.state,
								item.type,
								item.failCode
							)
						"
					></div>
				</div>
				<div class="task_checbox" v-if="!isChangeStatus">
					<img
						class="checked"
						src="../assets/top_allchecked.png"
						alt
						v-if="downloadingSelectedArray.includes(item.taskid)"
					/>
					<img
						class="unchecked"
						src="../assets/unchecked.png"
						alt
						v-else
					/>
				</div>
				<div class="task_btns" v-if="isChangeStatus">
					<a
						href="javascript:;"
						class="task_btn task_edit_btn"
						title="编辑"
						@click="editTaskDo(item)"
						v-if="
							item.type == 1 &&
							common.isLargeVersion(
								$store.state.user.ver,
								'1.1.22'
							)
						"
					></a>
					<a
						href="javascript:;"
						class="task_btn task_pause_btn"
						title="暂停"
						@click="pauseTask(item.taskid)"
						v-if="item.state == 1 || item.state == 0"
					></a>
					<a
						href="javascript:;"
						class="task_btn task_start_btn"
						title="开始"
						@click="startTask(item.taskid)"
						v-else
					></a>
					<a
						href="javascript:;"
						class="task_btn task_del_btn"
						title="删除"
						@click="showDel(item)"
					></a>
				</div>
			</div>
			<div
				class="list_empty"
				v-if="$store.state.downloadTaskInfoList.length == 0"
			>
				<div class="list_empty_body list_empty_download">
					当前没有下载任务
				</div>
			</div>
		</div>
		<div class="list_wrap" v-if="type == 'done'" @scroll="onScroll">
			<div class="list_top">
				<a href="javascript:;" class="add_btn" @click="showAdd"
					>添加下载链接</a
				>
				<a
					href="javascript:;"
					class="batch_btn"
					v-if="$store.state.doneTaskInfoList.length > 0"
					@click="ChangedoneStatus"
					>批量操作</a
				>
			</div>
			<div class="batch_box" v-if="!isdonechange">
				<div class="batch_box_checkmsg">
					已选中{{ doneSelectedArray.length }}个项目
				</div>
				<div class="top_btn all_btn" @click="checkeddoneAll">
					<img
						src="../assets/top_allchecked.png"
						v-show="isAlldoneChecked == true"
						alt
					/>
					<img
						src="../assets/unchecked.png"
						v-show="isAlldoneChecked == false"
						alt
					/>
					<span>全选</span>
				</div>
				<div
					class="top_btn del_btn"
					v-if="doneSelectedArray.length > 0"
					@click="showDoneDel($store.state.doneTaskInfoList)"
				>
					<img src="../assets/top_del_btn.png" alt />
					<span>删除</span>
				</div>
				<div class="top_btn del_btn_disable" v-else>
					<img src="../assets/top_del_btn_disable.png" alt />
					<span>删除</span>
				</div>
				<a
					href="javascript:;"
					class="finish_btn"
					@click="checkeddoneFinish"
					>完成</a
				>
			</div>
			<div
				class="list_item"
				:class="{
					list_item_checked: doneSelectedArray.includes(item.taskid),
				}"
				:key="item.taskid"
				v-for="item in $store.state.doneTaskInfoList"
				@click="isdonechange == false ? changedoneChecked(item) : ''"
			>
				<div class="task_type">
					<img :src="bt_icon" />
				</div>
				<div class="task_file">
					<div
						class="task_name"
						:title="item.name ? item.name : item.url"
					>
						{{ item.name ? item.name : item.url }}
					</div>
					<div class="task_size">
						{{ $common.formatSize(item.dlSize) }} /
						{{ $common.formatSize(item.size) }}
					</div>
				</div>
				<div class="task_time" v-if="false">
					{{ $common.formatTime(item.downTime) }}
				</div>
				<div class="task_progress" v-if="false">
					<div class="task_progress_wrap">
						<div
							class="task_progress_percent"
							:style="{
								width: getDownloadPercent(
									item.dlSize,
									item.size,
									item.state
								),
							}"
						></div>
					</div>
					<div class="task_speed">
						{{
							getDownloadSpeed(
								item.dlSpeed,
								item.state,
								item.type
							)
						}}
					</div>
				</div>
				<div class="task_done">下载完成</div>
				<div class="task_checbox" v-if="!isdonechange">
					<img
						class="checked"
						src="../assets/top_allchecked.png"
						alt
						v-if="doneSelectedArray.includes(item.taskid)"
					/>
					<img
						class="unchecked"
						src="../assets/unchecked.png"
						alt
						v-else
					/>
				</div>
				<div class="task_btns" v-if="isdonechange">
					<a
						href="javascript:;"
						class="task_btn task_del_btn"
						title="删除"
						@click="showDel(item)"
					></a>
				</div>
			</div>
			<div
				class="list_empty"
				v-if="$store.state.doneTaskInfoList.length == 0"
			>
				<div class="list_empty_body list_empty_done">暂无完成任务</div>
			</div>
		</div>
		<div class="list_wrap" v-if="type == 'del'" @scroll="onScroll">
			<div class="list_top">
				<a href="javascript:;" class="add_btn" @click="showAdd"
					>添加下载链接</a
				>
				<a
					href="javascript:;"
					class="top_btn clean_btn"
					@click="showClean"
					>清空垃圾站</a
				>
				<!-- <a href="javascript:;" class="top_btn del_btn">删除</a> -->
			</div>
			<div
				class="list_item"
				:key="item.taskid"
				v-for="item in $store.state.delTaskInfoList"
			>
				<div class="task_type">
					<img :src="bt_icon" />
				</div>
				<div class="task_file">
					<div
						class="task_name"
						:title="item.name ? item.name : item.url"
					>
						{{ item.name ? item.name : item.url }}
					</div>
					<div class="task_size">
						{{ $common.formatSize(item.dlSize) }} /
						{{ $common.formatSize(item.size) }}
					</div>
				</div>
				<div class="task_time task_create_time">
					{{ $common.formatDate(item.createTime * 1000) }}
				</div>
				<div class="task_progress" v-if="false">
					<div class="task_progress_wrap">
						<div
							class="task_progress_percent"
							:style="{
								width: getDownloadPercent(
									item.dlSize,
									item.size,
									item.state
								),
							}"
						></div>
					</div>
					<div class="task_speed">
						{{
							getDownloadSpeed(
								item.dlSpeed,
								item.state,
								item.type
							)
						}}
					</div>
				</div>
				<div class="task_btns">
					<a
						href="javascript:;"
						class="task_btn task_restore_btn"
						title="还原"
						@click="restoreTask(item.taskid, item.state)"
					></a>
					<a
						href="javascript:;"
						class="task_btn task_del_btn"
						title="删除"
						@click="showBinDel(item)"
					></a>
				</div>
			</div>
			<div
				class="list_empty"
				v-if="$store.state.delTaskInfoList.length == 0"
			>
				<div class="list_empty_body list_empty_del">垃圾箱很干净</div>
			</div>
		</div>
		<Del
			@onDelSubmit="onDelSubmit"
			@onDelCancel="onDelCancel"
			v-if="isShowDel"
		></Del>
		<Del
			type="all"
			@onDelSubmit="onAllDelSubmit"
			@onDelCancel="onAllDelCancel"
			v-if="isShowAllDel"
		></Del>
		<Del
			type="doneall"
			@onDelSubmit="onAllDoneDelSubmit"
			@onDelCancel="onAllDoneDelCancel"
			v-if="isShowAllDoneDel"
		></Del>
		<Del
			type="bin"
			@onDelSubmit="onBinDelSubmit"
			@onDelCancel="onBinDelCancel"
			v-if="isShowBinDel"
		></Del>
		<Del
			type="clean"
			@onDelSubmit="onCleanSubmit"
			@onDelCancel="onCleanCancel"
			v-if="isShowClean"
		></Del>
		<Box
			:task="editTask"
			@editTaskDone="editTaskDone"
			v-if="editTask"
		></Box>
		<div class="finish_msg" v-if="isShowMsg">操作完成</div>
	</div>
</template>

<script>
import Del from "./Del";
import Box from "@/components/Box.vue";
import { mapActions } from "vuex";
import common from "../common";
export default {
	components: {
		Del,
		Box,
	},
	data: function () {
		return {
			common: common,
			isShowDel: false,
			isShowAllDel: false,
			isShowAllDoneDel: false,
			isShowBinDel: false,
			isShowClean: false,
			isChangeStatus: true,
			isChecked: false,
			isdonechange: true,
			isShowMsg: false,
			isAllChecked: false,
			isAllfailChecked: false,
			isAlldoneChecked: false,
			delTaskItem: null,
			isRefreshIng: false,
			bt_icon: require("../assets/task_type_bt.png"),
			downloadingSelectedArray: [],
			doneSelectedArray: [],
			editTask: null,
		};
	},
	props: ["type"],
	methods: {
		...mapActions([
			"postTaskDel",
			"postTaskDelAll",
			"postTaskClean",
			"postTaskPause",
			"postTaskPauseAll",
			"postTaskStartAll",
			"postTaskStart",
			"postTaskRestore",
			"getTaskList",
			"getTaskListAll",
			"getTaskSub",
		]),
		editTaskDone: function () {
			let _that = this;
			_that.editTask = null;
		},
		editTaskDo: function (task) {
			let _that = this;
			console.log(task);
			_that.editTask = task;
		},
		onScroll: function (e) {
			let _that = this;
			// console.log(e.target.scrollTop);
			// console.log(e.target.clientHeight);
			// console.log(e.target.scrollHeight);
			if (
				e.target.scrollHeight - e.target.scrollTop <
				e.target.clientHeight + 100
			) {
				_that.refreshList();
			}
		},
		refreshList: function () {
			// console.log("refreshList");
			let _that = this;
			if (_that.isRefreshIng) {
				return;
			}
			_that.isRefreshIng = true;
			let listType = 0;
			let pos = 0;
			switch (_that.type) {
				case "download":
					listType = 0;
					pos = _that.$store.state.downloadTaskidList.length;
					break;
				case "done":
					listType = 1;
					pos = _that.$store.state.doneTaskidList.length;
					break;
				case "del":
					listType = 2;
					pos = _that.$store.state.delTaskidList.length;
					break;
				default:
					break;
			}
			_that.getTaskList([
				listType,
				pos,
				20,
				function (err, data) {
					setTimeout(function () {
						_that.isRefreshIng = false;
					}, 1000);
				},
			]);
		},
		getDownloadSpeed: function (speed, state, type, failCode) {
			let _that = this;
			let tips = "等待下载";
			switch (state) {
				case 0:
					{
						tips = "等待下载";
					}
					break;
				case 1:
					{
						tips = _that.$common.formatSize(speed) + "/s";
						if (type == 6) {
							tips = "任务解析并创建中";
						}
					}
					break;
				case 2:
					tips = "已暂停";
					break;
				case 3:
					tips = "已完成";
					break;
				case 4:
					{
						if (failCode == 4225) {
							tips =
								"<font style='color: #b12020;'>链接非法或版权限制</font>";
						} else {
							tips =
								"<font style='color: #b12020;'>下载失败</font>";
						}
					}
					break;
				case 5:
					tips = "已删除";
					break;
				default:
					break;
			}
			return tips;
		},
		getDownloadPercent: function (dlSize, size, state) {
			let percent = dlSize / size;
			if (state != 3 && percent == 1) {
				percent = 0.9999;
			}
			return percent * 100 + "%";
		},
		delTask: function (uuid, id, state, isRecycled, isDelFile) {
			let _that = this;
			_that.postTaskDel([
				_that.type,
				uuid,
				id,
				state,
				isRecycled,
				isDelFile,
			]);
		},
		delTaskAll: function (uuid, ids, state, isRecycled, isDelFile) {
			let _that = this;
			_that.postTaskDelAll([
				_that.type,
				uuid,
				ids,
				state,
				isRecycled,
				isDelFile,
			]);
		},
		getListAllTask: function (cb) {
			let _that = this;
			let listType = 0;
			let pos = 0;
			_that.$store.state.isShowLoading = true;
			switch (_that.type) {
				case "download":
					listType = 0;
					pos = _that.$store.state.downloadTaskidList.length;
					break;
				case "done":
					listType = 1;
					pos = _that.$store.state.doneTaskidList.length;
					break;
				case "del":
					listType = 2;
					pos = _that.$store.state.delTaskidList.length;
					break;
				default:
					break;
			}
			_that.getTaskListAll([
				listType,
				pos,
				function () {
					setTimeout(function () {
						_that.$store.state.isShowLoading = false;
						cb ? cb() : null;
					}, 1000);
				},
			]);
		},
		ChangeStatus: function () {
			let _that = this;
			_that.isChangeStatus = false;
			_that.isAllChecked = false;
			_that.isAllfailChecked = false;
			_that.getListAllTask();
			_that.$emit("ChangeStatus");
		},
		checkedAll: function () {
			let _that = this;
			// let allTaskId = [];
			let list = _that.$store.state.downloadTaskInfoList; // [{taskid:123},{taskid:234}]
			_that.isAllChecked = !this.isAllChecked;
			_that.isAllfailChecked = false;
			if (_that.isAllChecked == true) {
				for (let index = 0; index < list.length; index++) {
					const element = list[index];
					// const element2 = _that.downloadingSelectedArray[index];  // downloadingSelectedArray
					if (
						!_that.downloadingSelectedArray.includes(element.taskid)
					) {
						_that.downloadingSelectedArray.push(element.taskid);
					}
				}
				console.log("添加：" + _that.downloadingSelectedArray);
				console.log(
					"添加长度：" + _that.downloadingSelectedArray.length
				);
				// console.log("是否选中"+_that.isAllChecked);
			} else {
				_that.downloadingSelectedArray = [];
				// console.log("是否取消选中"+_that.isAllChecked);
			}
		},
		checkedAllfail: function () {
			let _that = this;
			let allfailTaskId = [];
			let list = _that.$store.state.downloadTaskInfoList;
			_that.isAllfailChecked = !this.isAllfailChecked;
			_that.isAllChecked = false;
			// let isHas = false;
			if (_that.isAllfailChecked == true) {
				for (let index = 0; index < list.length; index++) {
					const element = list[index];
					if (element.state == 4) {
						allfailTaskId.push(element.taskid);
					}
				}
				// console.log(allfailTaskId.length);
				_that.downloadingSelectedArray = allfailTaskId;
			} else {
				_that.downloadingSelectedArray = [];
			}
		},
		changeChecked: function (item) {
			let _that = this;
			let isHas = false;
			let checkedfail = [];
			for (
				let index = 0;
				index < _that.downloadingSelectedArray.length;
				index++
			) {
				const element = _that.downloadingSelectedArray[index];
				if (element == item.taskid) {
					isHas = true;
					_that.changeUnChecked(item);
					break;
				}
			}

			if (!isHas) {
				_that.downloadingSelectedArray.push(item.taskid);
				if (
					_that.downloadingSelectedArray.length ==
					_that.$store.state.downloadTaskInfoList.length
				) {
					_that.isAllChecked = true;
				}
			}
		},
		checkedFinish: function () {
			let _that = this;
			_that.isChangeStatus = !this.isChangeStatus;
			_that.downloadingSelectedArray = [];
			_that.$emit("checkedFinish");
		},
		checkeddoneFinish: function () {
			let _that = this;
			_that.isdonechange = !this.isdonechange;
			_that.doneSelectedArray = [];
			_that.$emit("checkeddoneFinish");
		},
		changeUnChecked: function (item) {
			let _that = this;
			// _that.isChecked = !this.isChecked;

			for (
				let index = 0;
				index < _that.downloadingSelectedArray.length;
				index++
			) {
				const element = _that.downloadingSelectedArray[index];
				if (element == item.taskid) {
					_that.downloadingSelectedArray.splice(index, 1);
					// console.log("移除" + _that.downloadingSelectedArray);
					// console.log(
					// 	"移除长度" + _that.downloadingSelectedArray.length
					// );
					_that.isAllChecked = false;
					_that.isAllfailChecked = false;
					break;
				}
			}
			// console.log(_that.downloadingSelectedArray);
		},
		ChangedoneStatus: function () {
			let _that = this;
			_that.isdonechange = false;
			_that.isAlldoneChecked = false;
			// _that.$eitm('ChangedoneStatus!_that.isdonechange);
			_that.$emit("ChangedoneStatus");
		},
		checkeddoneAll: function () {
			let _that = this;
			// let allTaskId = [];
			let item = _that.$store.state.doneTaskInfoList;
			_that.isAlldoneChecked = !this.isAlldoneChecked;
			if (_that.isAlldoneChecked == true) {
				for (let index = 0; index < item.length; index++) {
					const element = item[index];
					if (!_that.doneSelectedArray.includes(element.taskid)) {
						_that.doneSelectedArray.push(element.taskid);
					}
				}
				// console.log("添加：" + _that.doneSelectedArray);
				// console.log("是否选中"+_that.isAllChecked);
			} else {
				_that.doneSelectedArray = [];
				// console.log("是否取消选中"+_that.isAllChecked);
			}
		},
		changedoneChecked: function (item) {
			let _that = this;
			// _that.isChecked = !this.isChecked;

			let isHas = false;
			for (
				let index = 0;
				index < _that.doneSelectedArray.length;
				index++
			) {
				const element = _that.doneSelectedArray[index];
				if (element == item.taskid) {
					isHas = true;
					_that.changedoneUnChecked(item);
					break;
				}
			}

			if (!isHas) {
				_that.doneSelectedArray.push(item.taskid);
				// console.log("选中长度：" + _that.doneSelectedArray.length);
				// console.log(
				// 	"总长度：" + _that.$store.state.doneTaskInfoList.length
				// );
				if (
					_that.doneSelectedArray.length ==
					_that.$store.state.doneTaskInfoList.length
				) {
					_that.isAlldoneChecked = true;
				}
			}
		},
		changedoneUnChecked: function (item) {
			let _that = this;
			// _that.isChecked = !this.isChecked;

			for (
				let index = 0;
				index < _that.doneSelectedArray.length;
				index++
			) {
				const element = _that.doneSelectedArray[index];
				if (element == item.taskid) {
					_that.doneSelectedArray.splice(index, 1);
					// console.log("移除" + _that.doneSelectedArray);
					_that.isAlldoneChecked = false;
					break;
				}
			}
			// console.log(_that.doneSelectedArray);
		},
		showDel: function (item) {
			this.delTaskItem = item;
			this.isShowDel = true;
		},
		hideDel: function () {
			this.isShowDel = false;
		},
		showAllDel: function (item) {
			this.delTaskItem = item;
			this.isShowAllDel = true;
		},
		hideAllDel: function () {
			this.isShowAllDel = false;
		},
		showDoneDel: function (item) {
			this.delTaskItem = item;
			this.isShowAllDoneDel = true;
		},
		hideDoneDel: function () {
			this.isShowAllDoneDel = false;
		},
		showBinDel: function (item) {
			this.delTaskItem = item;
			this.isShowBinDel = true;
		},
		hideBinDel: function () {
			this.isShowBinDel = false;
		},
		showClean: function () {
			this.isShowClean = true;
		},
		hideClean: function () {
			this.isShowClean = false;
		},
		pauseTask: function (id) {
			let _that = this;
			_that.postTaskPause([id]);
		},
		pauseAllTask: function () {
			let _that = this;
			_that.postTaskPauseAll([]);
		},
		startTask: function (id) {
			let _that = this;
			_that.postTaskStart([id]);
		},
		startAllTask: function () {
			let _that = this;
			_that.postTaskStartAll([]);
		},
		restoreTask: function (id, state) {
			let _that = this;
			_that.postTaskRestore([id, state]);
		},
		showAdd: function () {
			this.$store.state.isShowAdd = true;
		},
		onDelSubmit: function (isDelTask, isDelFile) {
			let _that = this;
			_that.hideDel();
			_that.delTask(
				_that.delTaskItem.uuid,
				_that.delTaskItem.taskid,
				_that.delTaskItem.state,
				isDelTask,
				isDelFile
			);
		},
		onDelCancel: function (isDelTask, isDelFile) {
			// console.log("isDelFile", isDelFile);
			let _that = this;
			_that.hideDel();
		},
		onAllDelSubmit: function (isDelTask, isDelFile) {
			let _that = this;
			_that.hideAllDel();
			_that.delTaskAll(
				"",
				_that.downloadingSelectedArray,
				"",
				isDelTask,
				isDelFile
			);
			_that.downloadingSelectedArray = [];
			_that.isShowMsg = true;
			setTimeout(function () {
				_that.isShowMsg = false;
			}, 1500);
		},
		onAllDelCancel: function () {
			let _that = this;
			_that.hideAllDel();
		},
		onAllDoneDelSubmit: function (isDelTask, isDelFile) {
			let _that = this;
			_that.hideDoneDel();
			_that.delTaskAll(
				"",
				_that.doneSelectedArray,
				"",
				isDelTask,
				isDelFile
			);
			_that.doneSelectedArray = [];
			// console.log("11111111")
			// console.log(_that.doneSelectedArray);
			_that.isShowMsg = true;
			setTimeout(function () {
				_that.isShowMsg = false;
			}, 1500);
		},
		onAllDoneDelCancel: function () {
			let _that = this;
			_that.hideDoneDel();
		},
		onBinDelSubmit: function (isDelTask, isDelFile) {
			let _that = this;
			_that.hideBinDel();
			_that.delTask(
				_that.delTaskItem.uuid,
				_that.delTaskItem.taskid,
				_that.delTaskItem.state,
				isDelTask,
				isDelFile
			);
		},
		onBinDelCancel: function (isDelTask, isDelFile) {
			// console.log("isDelFile", isDelFile);
			let _that = this;
			_that.hideBinDel();
		},
		onCleanSubmit: function (isDelTask, isDelFile) {
			let _that = this;
			_that.hideClean();
			_that.getListAllTask(function () {
				_that.postTaskClean([isDelTask, isDelFile]);
			});
		},
		onCleanCancel: function (isDelTask, isDelFile) {
			let _that = this;
			_that.hideClean();
		},
	},
	mounted: function () {
		let _that = this;
	},
};
</script>

<style lang="less" scoped>
.list {
	width: 100%;
	height: 100%;
	overflow: hidden;
	.finish_msg {
		background: #666;
		color: #ffffff;
		height: 50px;
		width: 80px;
		position: fixed;
		top: 50%;
		left: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 10px;
	}
	.list_wrap {
		width: 100%;
		height: 100%;
		overflow-y: scroll;
		padding-bottom: 30px;
		box-sizing: border-box;
		padding-top: 50px;
		.list_top {
			height: 50px;
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
			background: linear-gradient(to bottom, #eaf1ff, #eaf1ff, #ffffff);
			z-index: 5;
			.add_btn {
				background-color: #06a8ff;
				width: 115px;
				height: 30px;
				padding-left: 15px;
				text-align: center;
				display: inline-block;
				vertical-align: middle;
				color: #ffffff;
				font-size: 12px;
				line-height: 30px;
				background-image: url(../assets/add_btn_icon.png);
				background-position: 10px center;
				background-repeat: no-repeat;
				background-size: 12px 12px;
				margin-left: 20px;
				margin-top: 10px;
				border-radius: 2px;
				box-sizing: border-box;
			}
			.add_btn:hover {
				background-color: #3f85ca;
			}
			.top_btn {
				margin-left: 20px;
				margin-top: 10px;
				height: 28px;
				line-height: 28px;
				border: 1px solid #c3eaff;
				padding-left: 30px;
				padding-right: 12px;
				display: inline-block;
				vertical-align: middle;
				color: #0793dd;
				font-size: 12px;
				background-color: #ffffff;
				border-radius: 2px;
				background-repeat: no-repeat;
				background-position: 12px center;
			}
			.top_btn:hover {
				background-color: #f7faff;
			}
			.pause_btn {
				background-image: url(../assets/top_pause_btn.png);
				background-size: 8px 12px;
			}
			.start_btn {
				background-image: url(../assets/top_start_btn.png);
				background-size: 12px 12px;
			}
			.batch_btn {
				background-color: #06a8ff;
				width: 94px;
				height: 30px;
				padding-left: 15px;
				text-align: center;
				// display: inline-block;
				vertical-align: middle;
				color: #ffffff;
				font-size: 12px;
				line-height: 30px;
				background-image: url(../assets/batch_btn_icon.png);
				background-position: 10px center;
				background-repeat: no-repeat;
				background-size: 12px 13px;
				margin-left: 20px;
				margin-top: 10px;
				border-radius: 2px;
				box-sizing: border-box;
				float: right;
				margin-right: 30px;
			}
			// .del_btn {
			// 	background-image: url(../assets/top_del_btn.png);
			// 	background-size: 12px 12px;
			// }
			.clean_btn {
				background-image: url(../assets/top_clean_btn.png);
				background-size: 12px 12px;
			}
		}
		.batch_box {
			height: 50px;
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
			background: linear-gradient(to bottom, #eaf1ff, #eaf1ff, #ffffff);
			z-index: 5;
			display: flex;
			justify-content: flex-end;

			.batch_box_checkmsg {
				display: flex;
				justify-content: center;
				align-items: center;
				color: #888888;
			}
			.top_btn {
				margin-left: 20px;
				margin-top: 10px;
				height: 28px;
				line-height: 28px;
				border: 1px solid #c3eaff;
				display: inline-block;
				vertical-align: middle;
				color: #0793dd;
				font-size: 12px;
				background-color: #ffffff;
				border-radius: 2px;
				display: flex;
				align-items: center;
				cursor: pointer;
			}

			.del_btn_disable {
				color: #b2b2b2;
				border: 1px solid #b2b2b2;
			}

			.all_btn,
			.allfail_btn,
			.del_btn,
			.del_btn_disable {
				img {
					width: 12px;
					height: 13px;
					background-size: 100%;
					margin-left: 13px;
					margin-right: 10px;
				}
				span {
					margin-right: 12px;
				}
			}
			// .allfail_btn{
			// 	background-image: url(../assets/top_allfail_btn.png);
			// 	background-size: 12px 12px;
			// }
			// .del_btn{
			// 	background-image: url(../assets/top_del_btn.png);
			// 	background-size: 12px 12px;
			// }
			.finish_btn {
				margin-left: 20px;
				margin-right: 40px;
				margin-top: 10px;
				height: 28px;
				line-height: 28px;
				// border: 1px solid #c3eaff;
				padding-left: 40px;
				padding-right: 12px;
				display: inline-block;
				vertical-align: middle;
				color: #fff;
				font-size: 12px;
				background-color: #06a8ff;
				border-radius: 2px;
				background-repeat: no-repeat;
				background-position: 20px center;
				background-image: url(../assets/top_finish_btn.png);
				background-size: 12px 12px;
				// background-repeat: no-repeat;
				// background-position: 12px center;
			}
		}
	}
	.list_item {
		height: 55px;
		border-bottom: 1px solid #e3e3e3;
		position: relative;
		cursor: pointer;

		.task_type {
			width: 23px;
			height: 23px;
			display: inline-block;
			vertical-align: top;
			margin-left: 20px;
			margin-top: 12px;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.task_file {
			display: inline-block;
			vertical-align: top;
			margin-left: 12px;
			margin-top: 10px;
			width: 40%;
			overflow-x: hidden;
			.task_name {
				color: #555555;
				font-size: 12px;
				display: inline-block;
				white-space: nowrap;
				width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.task_size {
				color: #aaaaaa;
				font-size: 12px;
				margin-top: 4px;
				transform: scale(0.9);
				transform-origin: left;
			}
		}
		.task_btns {
			position: absolute;
			top: 24px;
			right: 27px;
			display: none;
			.task_btn {
				display: inline-block;
				vertical-align: top;
				background-image: url(../assets/list_pause_btn.png);
				background-position: center center;
				background-repeat: no-repeat;
				background-size: 100% 100%;
			}
			.task_btn:hover {
				opacity: 0.5;
			}
			.task_edit_btn {
				width: 14px;
				height: 14px;
				background-image: url(../assets/list_edit_btn.png);
				margin-right: 22px;
				margin-top: -2px;
			}
			.task_pause_btn {
				width: 8px;
				height: 12px;
				background-image: url(../assets/list_pause_btn.png);
				margin-right: 25px;
			}
			.task_del_btn {
				width: 12px;
				height: 12px;
				background-image: url(../assets/list_del_btn.png);
			}
			.task_start_btn {
				width: 12px;
				height: 15px;
				margin-right: 25px;
				margin-top: -2px;
				background-image: url(../assets/list_start_btn.png);
			}
			.task_restore_btn {
				width: 12px;
				height: 12px;
				margin-right: 25px;
				background-image: url(../assets/list_restore_btn.png);
			}
		}
		.task_time {
			display: inline-block;
			vertical-align: top;
			margin-top: 12px;
			color: #999999;
			font-size: 12px;
			width: 120px;
			text-align: right;
			margin-right: 30px;
			word-break: break-all;
		}
		.task_create_time {
			margin-top: 20px;
			width: 240px;
		}
		.task_done {
			display: inline-block;
			vertical-align: top;
			color: #999999;
			font-size: 12px;
			margin-top: 20px;
			padding-left: 20px;
			background-image: url(../assets/list_done_icon.png);
			background-size: 12px 12px;
			background-position: left center;
			background-repeat: no-repeat;
			margin-left: 200px;
		}
		.task_progress {
			display: inline-block;
			vertical-align: top;
			margin-top: 18px;
			.task_progress_wrap {
				width: 150px;
				height: 4px;
				background-color: #e5e6ea;
				.task_progress_percent {
					height: 4px;
					width: 0%;
					background-color: #0ea2f1;
					display: inline-block;
					vertical-align: top;
				}
			}
			.task_speed {
				color: #999999;
				font-size: 12px;
				margin-top: 5px;
			}
		}
		.checkcol {
			background-color: #fefaeb;
		}
		.task_checbox {
			width: 23px;
			height: 23px;
			// display: inline-block;
			vertical-align: top;
			float: right;
			margin-right: 50px;
			margin-top: 20px;
			cursor: pointer;

			img {
				width: 12px;
				height: 12px;
			}
			// .checbox{
			// 	width: 12px;
			// 	height: 13px;
			// 	display: inline-block;
			// 	border: 1px solid #0EA2F1;
			// 	border-radius: 3px;

			// }
		}
	}
	.list_item:hover {
		background-color: #fefaeb;
		.task_btns {
			display: block;
		}
	}
	.list_item_checked {
		background-color: #fefaeb;
	}

	.list_empty {
		width: 100%;
		height: 100%;
		position: relative;
		.list_empty_body {
			width: 150px;
			margin-left: -75px;
			margin-top: -150px;
			padding-top: 170px;
			height: 30px;
			position: absolute;
			left: 50%;
			top: 50%;
			background-repeat: no-repeat;
			background-position: center top;
			background-size: 100% auto;
			text-align: center;
			color: #c0c0c0;
			font-size: 14px;
		}
		.list_empty_download {
			background-image: url(../assets/list_download_empty.png);
		}
		.list_empty_del {
			background-image: url(../assets/list_del_empty.png);
		}
		.list_empty_done {
			background-image: url(../assets/list_done_empty.png);
		}
	}
}

@media screen and (max-width: 1000px) {
	.list {
		.list_item {
			.task_time {
				width: 60px;
				margin-top: 12px;
			}
			.task_progress {
				.task_progress_wrap {
					width: 100px;
				}
			}
		}
	}
}
</style>